<template>
  <div class="project-edit">
    <app-view-layout
      header="Edycja Akcydensu"
      :subheader="commercialPrint.name"
    >
      <template #toolbarMenu>
        <AppNavigateBack
          :prev-route="prevRoute"
          class="mr-4"
        />
      </template>

      <template #content>
        <v-form
          ref="updateCommercialPrintForm"
          v-model="isFormValid"
          @submit.prevent="submit"
        >
          <CPFormCard
            v-model="commercialPrintData"
            class="mt-4 mb-8"
          />

          <AppTextCard
            v-model="commercialPrintData.description"
            class="mb-8"
            required
            :disabled="!commercialPrintData.editable"
            title="Opis projektu *"
          />

          <v-btn
            class="my-8"
            color="primary"
            type="submit"
            height="40"
            max-width="120"
            :loading="isProcessing"
          >
            Zapisz zmiany
          </v-btn>
        </v-form>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import navigateBack from '@/helpers/navigateBackMixin';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import CPFormCard from '@/components/CommercialPrint/CPFormCard.vue';
import AppTextCard from '@/components/UI/AppTextCard.vue';
import AppNavigateBack from '@/components/UI/AppNavigateBack.vue';

export default {
  components: {
    AppViewLayout,
    CPFormCard,
    AppTextCard,
    AppNavigateBack,
  },

  mixins: [navigateBack],

  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      isFormValid: true,
      commercialPrintData: {
        id: '',
        name: '',
        description: '',
        createdAt: '',
        deadline: '',
        commercialPrintType: '',
        status: '',
        members: [],
        orderers: [],
        managers: [],
        discLocation: '',
        files: [],
        history: {
          changes: [],
          total: 0,
        },
      },
    };
  },

  computed: {
    ...mapState('commercialPrintSingle', ['commercialPrint', 'isProcessing']),
    ...mapGetters('auth', ['checkUserPermissions']),
  },

  created() {
    this.fetchSingleCommercialPrint(this.id).then(() => {
      this.commercialPrintData = this.commercialPrint;
      this.$refs.updateCommercialPrintForm.resetValidation();
    });
  },

  beforeRouteLeave(to, from, next) {
    if (to.name !== 'commercial-print-single') this.resetCommercialPrint();
    next();
  },
  methods: {
    ...mapActions('commercialPrintSingle', [
      'fetchSingleCommercialPrint',
      'resetCommercialPrint',
      'updateCommercialPrint',
      'updateProject',
    ]),

    ...mapActions('snackbar', ['showSnackbar']),

    submit() {
      this.$refs.updateCommercialPrintForm.validate();

      if (this.isFormValid) {
        this.updateProject(this.commercialPrintData);
      } else {
        this.$vuetify.goTo(0);
        this.showSnackbar({
          message: ['Występują błędy/braki w formularzu'],
          type: 'error',
        });
      }
    },
  },
};
</script>
